<template>
  <!-- Every CMS screen: a white card with the page title (and optional actions) at the top. -->
  <div class="content-layout">
    <div class="content-layout__header">
      <div class="content-layout__heading">
        <h1 class="content-layout__header__title">
          <slot name="header"></slot>
        </h1>
        <p v-if="$slots.description" class="content-layout__description">
          <slot name="description"></slot>
        </p>
      </div>
      <div v-if="$slots['header-right']" class="content-layout__actions">
        <slot name="header-right"></slot>
      </div>
    </div>

    <div class="content-layout__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "content-layout"
  }
</script>

<style scoped>

  .content-layout {
    min-height: calc(100vh - 92px);
    box-sizing: border-box;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background-color: white;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  }

  .content-layout__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 32px;
    border-bottom: 1px solid var(--border);
  }

  .content-layout__header__title {
    margin: 0;
    font-size: 24px;
    line-height: 32px;
  }

  .content-layout__description {
    max-width: 720px;
    margin: 4px 0 0;
    color: var(--text-muted);
    font-size: 13px;
    line-height: 1.6;
  }

  .content-layout__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  .content-layout__body {
    padding: 24px 32px 32px;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/content-layout.vue